"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var RailCarTankCoupled = function RailCarTankCoupled(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "54.78",
    height: "24",
    viewBox: "0 0 54.78 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M26.61,17.41h-6a3.25,3.25,0,0,0-.39-.35A8.21,8.21,0,0,0,16.83,1.39H13V.75A.76.76,0,0,0,12.26,0H8A.75.75,0,0,0,7.2.75v.64H0V2.88H16.83A6.71,6.71,0,0,1,18,16.2l-.22,0a3.45,3.45,0,0,0-1,.14h-6a3.43,3.43,0,0,0-1.94,0H0v4.47H6.06a3.91,3.91,0,1,0,7-3h1.58A3.9,3.9,0,0,0,17.82,24a3.92,3.92,0,0,0,3.91-3.91A4,4,0,0,0,21.55,19h5.09a.76.76,0,0,0,.75-.75v0A.78.78,0,0,0,26.61,17.41Zm-16.71,5a2.34,2.34,0,0,1-.57-4.62h1.15a2.35,2.35,0,0,1-.58,4.62Zm7.92,0a2.35,2.35,0,0,1-.5-4.65l.56-.05a2.35,2.35,0,0,1-.06,4.7Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M27.39,18.19v0a.75.75,0,0,0,.75.75h5.09a4,4,0,0,0-.18,1.11,3.91,3.91,0,1,0,7.08-2.27h1.58a3.9,3.9,0,1,0,7,3h6.06V16.32H45.85a3.45,3.45,0,0,0-1-.14,3.57,3.57,0,0,0-1,.14h-6a3.45,3.45,0,0,0-1-.14l-.22,0A6.71,6.71,0,0,1,38,2.88H54.78V1.39h-7.2V.75A.75.75,0,0,0,46.83,0H42.52a.76.76,0,0,0-.75.75v.64H38a8.21,8.21,0,0,0-3.43,15.67,3.25,3.25,0,0,0-.39.35h-6A.78.78,0,0,0,27.39,18.19Zm15.14,1.9a2.33,2.33,0,0,1,1.77-2.27h1.15a2.35,2.35,0,1,1-2.92,2.27Zm-7.92,0a2.35,2.35,0,0,1,2.29-2.35l.56.05a2.35,2.35,0,1,1-2.85,2.3Z"
  }));
};

var _default = RailCarTankCoupled;
exports["default"] = _default;